import React from "react";

import { Box, TextField, Typography } from "@mui/material";

import CustomButton from "../../../helper-components/input/CustomButton";

export default function MfaChallenge(props) {
    const { challenge, onSubmit, onCancel } = props;
    const [code, setCode] = React.useState("");
    const [useBackup, setUseBackup] = React.useState(false);
    const enrolling = challenge?.status === "mfa_enroll";

    const submit = (event) => {
        event.preventDefault();
        if (!code.trim()) return;
        onSubmit(code.trim());
    };

    return (
        <Box component="form" onSubmit={submit} sx={{ mt: 1, width: "100%" }}>
            {enrolling ? (
                <>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                        Scan this QR code with Google Authenticator, or type the secret by hand. Then enter the 6-digit code.
                    </Typography>
                    {challenge.qr_data_uri && (
                        <Box component="img" alt="Authenticator QR code" src={challenge.qr_data_uri} sx={{ width: 180, height: 180, display: "block", mx: "auto", my: 1 }} />
                    )}
                    <Typography variant="caption" component="p" sx={{ fontFamily: "monospace", wordBreak: "break-all", textAlign: "center", mb: 1 }}>
                        {challenge.secret}
                    </Typography>
                </>
            ) : (
                <Typography variant="body2" sx={{ mb: 1 }}>
                    {useBackup ? "Enter one of your backup codes. Each code works once." : "Enter the 6-digit code from your authenticator app."}
                </Typography>
            )}

            <TextField
                margin="normal"
                required
                fullWidth
                autoFocus
                name="mfaCode"
                label={useBackup ? "Backup code" : "Authenticator code"}
                value={code}
                onChange={(event) => setCode(event.target.value)}
                inputProps={{ autoComplete: "one-time-code", inputMode: useBackup ? "text" : "numeric" }}
            />

            <CustomButton {...props} title={enrolling ? "Confirm authenticator" : "Verify and sign in"} type="submit" fullWidth />
            {!enrolling && (
                <CustomButton
                    {...props}
                    title={useBackup ? "Use authenticator code" : "Use a backup code"}
                    type="button"
                    variant="text"
                    onClick={() => {
                        setUseBackup((current) => !current);
                        setCode("");
                    }}
                />
            )}
            <CustomButton {...props} title="Back" type="button" variant="text" onClick={onCancel} />
        </Box>
    );
}
